import { Flame, Wind, Eye, Shield, Star, Zap, Gauge } from 'lucide-react';
import type { StatDef } from '../../packs/types';

const ICONS = { flame: Flame, wind: Wind, eye: Eye, shield: Shield, star: Star, zap: Zap, gauge: Gauge };

interface StatsPanelProps {
  stats: StatDef[];
  values: Record<string, number>;
  accentHue: number;
}

export function StatsPanel({ stats, values, accentHue }: StatsPanelProps) {
  const visible = stats.filter(s => !s.hidden);
  if (visible.length === 0) return null;

  const barColor = `hsl(${accentHue}, 75%, 55%)`;
  const trackColor = `hsl(${accentHue}, 25%, 18%)`;

  return (
    <div className="px-3 pb-3" data-testid="stats-panel">
      <div className="text-xs text-slate-500 px-1 pb-2">Stats</div>
      <div className="space-y-1.5">
        {visible.map(stat => {
          const Icon = ICONS[stat.iconKey] ?? Zap;
          const value = values[stat.id] ?? 0;
          const pct = Math.max(0, Math.min(100, (value / stat.max) * 100));
          return (
            <div key={stat.id} className="flex items-center gap-2">
              <Icon size={14} style={{ color: barColor }} aria-hidden="true" />
              <div className="text-xs font-medium text-slate-300" style={{ width: 78 }}>{stat.label}</div>
              <div
                className="flex-1 h-2 rounded-full overflow-hidden"
                style={{ background: trackColor }}
              >
                <div
                  className="h-full rounded-full transition-[width] duration-200"
                  style={{ width: `${pct}%`, background: barColor }}
                />
              </div>
              <div className="text-xs font-mono text-slate-300" style={{ width: 28, textAlign: 'right' }}>{value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
